import { AxiosError } from 'axios';
import { Problem } from './Problem';

export function isProblem(axiosError: AxiosError): axiosError is AxiosError<Problem> & { response: { data: Problem } } {
    const contentType = axiosError.response?.headers['content-type'];
    return (
        axiosError.isAxiosError &&
        typeof contentType === 'string' &&
        contentType.toLowerCase().startsWith('application/problem+json') &&
        axiosError.response!.data != null
    );
}
